import IconDark from "@/assets/icons/back-arrow-dark.svg"
import Icon from "@/assets/icons/back-arrow-white.svg"
import { Pressable, type StyleProp, type ViewStyle } from "react-native"
import { useRouter } from "expo-router"
import { cn } from "@/components/util/cn"

interface BFBackButtonProps {
  dark?: boolean
  onBack?: () => void
  className?: string
  style?: StyleProp<ViewStyle>
}

export const BFBackButton = ({
  dark = false,
  onBack,
  className,
  style,
}: BFBackButtonProps) => {
  const router = useRouter()

  function onPress() {
    if (onBack) {
      onBack()
      return
    }

    router.back()
  }

  if (!router.canGoBack() && !onBack) {
    return null
  }

  return (
    <Pressable
      testID="backButton"
      onPress={onPress}
      hitSlop={20}
      style={style}
      className={cn("p-1", className)}
    >
      {dark ? <IconDark /> : <Icon />}
    </Pressable>
  )
}
